(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define([], function(){ return factory(root); });
  } else if (typeof module === 'object' && module.exports) {
    module.exports = factory(globalThis || (typeof self !== 'undefined' ? self : this));
  } else {
    root.SwishPickleballLines = factory(root);
  }
}(typeof self !== 'undefined' ? self : this, function (GLOBAL) {
  'use strict';

  function normHex(x){ if(!x) return '#FFFFFF'; x=String(x).trim(); if(x[0] !== '#') x='#'+x; return x.toUpperCase(); }
  function hasKeys(obj) {
    if (!obj) return false;
    for (const _ in obj) return true;
    return false;
  }
  function resolveOfficial(rulesetId) {
    const cfg = GLOBAL && GLOBAL.SwishCBConfig;
    if (cfg && typeof cfg.resolveOfficialCourtGeometry === 'function') {
      try { return cfg.resolveOfficialCourtGeometry(rulesetId, { noSeries: true }); } catch (_) {}
    }
    return null;
  }

  const FT = 0.3048;
  const OFFICIAL = resolveOfficial('PICKLEBALL');
  const OFFICIAL_RAW = (OFFICIAL && OFFICIAL.official) || {};
  const COURT = {
    LENGTH: Number(OFFICIAL && OFFICIAL.officialLengthM) || (44 * FT),
    WIDTH: Number(OFFICIAL && OFFICIAL.officialWidthM) || (20 * FT),
    NVZ: Number(OFFICIAL_RAW.nonVolleyZone) || (7 * FT),
    LINE: Number(OFFICIAL && OFFICIAL.lineWidthM) || 0.0508
  };
  const HALF_LENGTH = COURT.LENGTH / 2;
  const HALF_WIDTH = COURT.WIDTH / 2;
  // USA Pickleball measures the NVZ distance to the outside edge of the line.
  const LEFT_SERVICE_END = HALF_LENGTH - COURT.NVZ + (COURT.LINE * 0.5);
  const RIGHT_SERVICE_START = HALF_LENGTH + COURT.NVZ - (COURT.LINE * 0.5);
  const RIGHT_SERVICE_WIDTH = COURT.LENGTH - RIGHT_SERVICE_START;
  const SKIP_COLOR = '__SKIP__';

  function makePart(id, order, role, fallback, side, draw) {
    return { id, order, role, fallback, side, draw };
  }

  function fillRect(ctx, dims, color, x, y, w, h) {
    ctx.fillStyle = (GLOBAL.SwishCBHardwood && typeof GLOBAL.SwishCBHardwood.getFillStyle === 'function')
      ? GLOBAL.SwishCBHardwood.getFillStyle(ctx, color, { hardwood: dims.hardwood, pixelsPerMeter: dims.scaleAvg })
      : color;
    ctx.fillRect(
      x * dims.scaleX,
      y * dims.scaleY,
      w * dims.scaleX,
      h * dims.scaleY
    );
  }

  // Use filled rects instead of strokes to keep line thickness visually uniform.
  function fillLineH(ctx, dims, color, x1, x2, yM, widthM, align) {
    const wPx = widthM * dims.scaleAvg;
    const xPx1 = x1 * dims.scaleX;
    const xPx2 = x2 * dims.scaleX;
    const left = Math.min(xPx1, xPx2);
    const width = Math.abs(xPx2 - xPx1);
    const yPx = yM * dims.scaleY;
    const top =
      align === 'inside-top' ? yPx :
      align === 'inside-bottom' ? (yPx - wPx) :
      (yPx - wPx / 2);
    ctx.fillStyle = color;
    ctx.fillRect(left, top, width, wPx);
  }

  function fillLineV(ctx, dims, color, xM, y1, y2, widthM, align) {
    const wPx = widthM * dims.scaleAvg;
    const yPx1 = y1 * dims.scaleY;
    const yPx2 = y2 * dims.scaleY;
    const top = Math.min(yPx1, yPx2);
    const height = Math.abs(yPx2 - yPx1);
    const xPx = xM * dims.scaleX;
    const left =
      align === 'inside-left' ? xPx :
      align === 'inside-right' ? (xPx - wPx) :
      (xPx - wPx / 2);
    ctx.fillStyle = color;
    ctx.fillRect(left, top, wPx, height);
  }

  const PARTS = [
    // Left service side
    makePart('pickleLeftUpperService', 10, 'area', 'main', 'left', (ctx, dims, color) => {
      fillRect(ctx, dims, color, 0, 0, LEFT_SERVICE_END, HALF_WIDTH);
    }),
    makePart('pickleLeftLowerService', 20, 'area', 'main', 'left', (ctx, dims, color) => {
      fillRect(ctx, dims, color, 0, HALF_WIDTH, LEFT_SERVICE_END, HALF_WIDTH);
    }),
    makePart('pickleLeftKitchen', 30, 'area', 'key', 'left', (ctx, dims, color) => {
      fillRect(ctx, dims, color, LEFT_SERVICE_END, 0, COURT.NVZ, COURT.WIDTH);
    }),
    // Right service side
    makePart('pickleRightUpperService', 40, 'area', 'main', 'right', (ctx, dims, color) => {
      fillRect(ctx, dims, color, RIGHT_SERVICE_START, 0, RIGHT_SERVICE_WIDTH, HALF_WIDTH);
    }),
    makePart('pickleRightLowerService', 50, 'area', 'main', 'right', (ctx, dims, color) => {
      fillRect(ctx, dims, color, RIGHT_SERVICE_START, HALF_WIDTH, RIGHT_SERVICE_WIDTH, HALF_WIDTH);
    }),
    makePart('pickleRightKitchen', 60, 'area', 'key', 'right', (ctx, dims, color) => {
      fillRect(ctx, dims, color, HALF_LENGTH, 0, COURT.NVZ, COURT.WIDTH);
    }),
    // Lines
    makePart('pickleSidelineTop', 200, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillLineH(ctx, dims, color, 0, COURT.LENGTH, 0, COURT.LINE, 'inside-top');
    }),
    makePart('pickleSidelineBottom', 210, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillLineH(ctx, dims, color, 0, COURT.LENGTH, COURT.WIDTH, COURT.LINE, 'inside-bottom');
    }),
    makePart('pickleBaselineLeft', 220, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillLineV(ctx, dims, color, 0, 0, COURT.WIDTH, COURT.LINE, 'inside-left');
    }),
    makePart('pickleBaselineRight', 230, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillLineV(ctx, dims, color, COURT.LENGTH, 0, COURT.WIDTH, COURT.LINE, 'inside-right');
    }),
    makePart('pickleCenterLine', 240, 'line', 'lines', 'center', (ctx, dims, color) => {
      // Service centerline should stop at each non-volley zone line
      fillLineH(ctx, dims, color, 0, LEFT_SERVICE_END, HALF_WIDTH, COURT.LINE, 'center');
      fillLineH(ctx, dims, color, RIGHT_SERVICE_START, COURT.LENGTH, HALF_WIDTH, COURT.LINE, 'center');
    }),
    makePart('pickleNvzLineLeft', 250, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillLineV(ctx, dims, color, LEFT_SERVICE_END, 0, COURT.WIDTH, COURT.LINE, 'center');
    }),
    makePart('pickleNvzLineRight', 260, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillLineV(ctx, dims, color, RIGHT_SERVICE_START, 0, COURT.WIDTH, COURT.LINE, 'center');
    })
  ];

  const PART_LOOKUP = PARTS.reduce((acc, part) => {
    acc[part.id] = part;
    return acc;
  }, Object.create(null));
  const DRAW_ORDER = PARTS.slice().sort((a, b) => a.order - b.order).map(part => part.id);
  const LINE_ONLY_ORDER = DRAW_ORDER.filter(id => PART_LOOKUP[id] && PART_LOOKUP[id].role === 'line');

  function computeDims(cw, ch) {
    const scaleX = cw / COURT.LENGTH;
    const scaleY = ch / COURT.WIDTH;
    return {
      scaleX,
      scaleY,
      scaleAvg: (scaleX + scaleY) * 0.5,
      cw,
      ch
    };
  }

  function pickDetailColor(detailColors, fallbackColors, id, fallback, baseColor) {
    if (detailColors && detailColors[id]) {
      if (detailColors[id] === SKIP_COLOR) return null;
      return detailColors[id];
    }
    if (fallbackColors && fallbackColors[id]) {
      if (fallbackColors[id] === SKIP_COLOR) return null;
      return fallbackColors[id];
    }
    if (fallback === 'key') return baseColor.key || baseColor.main;
    if (fallback === 'border') return baseColor.border || baseColor.main;
    if (fallback === 'lines') return baseColor.lines;
    return baseColor.main;
  }

  const DEFAULT_PALETTE = {
    main: '#0F4C81',
    key: '#27C498',
    border: '#0A2F4C',
    lines: '#FFFFFF'
  };

  function draw(ctx, x0, y0, cw, ch, color, opts) {
    if (!ctx || !cw || !ch) return;
    const detailColors = (opts && opts.detailColors) || null;
    const fallbackColors = (opts && opts.fallbackColors) || null;
    const only = (opts && (opts.only === 'left' || opts.only === 'right')) ? opts.only : null;
    const useDetailedParts = !!(opts && opts.useDetailedParts);
    const hasCustom = hasKeys(detailColors) || hasKeys(fallbackColors);
    const drawDetailed = useDetailedParts || hasCustom;
    const order = drawDetailed ? DRAW_ORDER : LINE_ONLY_ORDER;

    ctx.save();
    ctx.translate(x0, y0);
    const dims = computeDims(cw, ch);
    dims.hardwood = opts && opts.hardwood;
    const palette = {
      main: DEFAULT_PALETTE.main,
      key: DEFAULT_PALETTE.key,
      border: DEFAULT_PALETTE.border,
      lines: normHex(color || DEFAULT_PALETTE.lines)
    };

    for (const id of order) {
      const part = PART_LOOKUP[id];
      if (!part) continue;
      if (only && part.side && part.side !== only && part.side !== 'center') continue;
      const fill = pickDetailColor(detailColors, fallbackColors, id, part.fallback, palette);
      if (!fill) continue;
      try {
        part.draw(ctx, dims, normHex(fill));
      } catch (err) {
        console.warn('[SwishPickleballLines] draw error for part', id, err);
      }
    }

    ctx.restore();
  }

  const api = {
    design: { W: COURT.WIDTH * 1000, L: COURT.LENGTH * 1000 },
    draw,
    ready: Promise.resolve()
  };

  return api;
}));
